module.exports = __webpack_public_path__ + "static/media/022-file-sharing.d8bcdafc.svg";